import { useState } from "react";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useAiStream } from "@/lib/ai";

const TONES = { vriendelijk: "Vriendelijk", zakelijk: "Zakelijk", kort: "Kort & krachtig" };

export const AiBoardWriter = ({ onText }) => {
  const stream = useAiStream();
  const [open, setOpen] = useState(false);
  const [idea, setIdea] = useState("");
  const [tone, setTone] = useState("vriendelijk");
  const [busy, setBusy] = useState(false);

  const write = async () => {
    setBusy(true);
    try {
      await stream("/ai/board-message", { idea, tone }, onText);
      setOpen(false);
      setIdea("");
      toast.success("Concept staat klaar. Controleer en plaats het.");
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Button variant="outline" className="rounded-full" onClick={() => setOpen(true)} data-testid="ai-board-writer-button">
        <Sparkles className="h-4 w-4 mr-2 text-[#FF5A36]" />Schrijf met AI
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="ai-board-writer-dialog">
          <DialogHeader>
            <DialogTitle>Bericht schrijven met AI</DialogTitle>
            <DialogDescription>Vertel kort wat je wilt zeggen. Je kunt de tekst daarna nog aanpassen.</DialogDescription>
          </DialogHeader>
          <Textarea value={idea} onChange={(e) => setIdea(e.target.value)} rows={4} placeholder="Bijv. zaterdag is de keuken dicht vanwege onderhoud, iedereen begint om 17:00" data-testid="ai-board-idea-input" />
          <div className="flex flex-wrap gap-2">
            {Object.entries(TONES).map(([k, v]) => (
              <button key={k} onClick={() => setTone(k)} className={`rounded-full px-3 py-1 text-xs font-semibold transition-all ${tone === k ? "bg-[#0D5C46] text-white" : "bg-white border border-slate-200 text-slate-600"}`} data-testid={`ai-board-tone-${k}`}>{v}</button>
            ))}
          </div>
          <DialogFooter>
            <Button onClick={write} disabled={busy || idea.trim().length < 3} data-testid="ai-board-generate-button">{busy ? "Aan het schrijven…" : "Schrijf bericht"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
